module.exports = __webpack_public_path__ + "img/curve_1@2x.5dc02d5c.png";